export default __webpack_public_path__ + "static/rs-logo-black-8791e41a0bdcc2fa8079a7261af3b110.svg";